import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Subscription } from 'rxjs';

export interface FormMetaData {
    timeSheets?: {
        filterOptions?: any[];
        table?: any[];
    };
}

@Injectable({
    providedIn: 'root'
})
export class FormService implements OnDestroy {
    metaData: FormMetaData;
    isLoaded: boolean = false;
    subscriptions: Subscription[] = [];

    // Subject to notify when metadata is loaded
    private metaDataLoaded$ = new Subject<FormMetaData>();
    public onMetaDataLoaded = this.metaDataLoaded$.asObservable();

    constructor(private http: HttpClient) { }

    getFormData() {
        const url = `./assets/app.json?cachebuster=${new Date().getTime()}`;
        this.http.get(url).subscribe((data: FormMetaData) => {
            this.metaData = data;
            this.isLoaded = true;
            this.metaDataLoaded$.next(data);
            console.log('✅ EmployeePortal FormService - Metadata loaded successfully');
        }, error => {
            console.error('❌ EmployeePortal FormService - Failed to load metadata:', error);
        });
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
